import React from 'react';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { clusterApiUrl } from '@solana/web3.js';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';

// Import other pages
import HomePage from "./pages/HomePage";
import LaunchpadList from "./pages/LaunchpadList";
import LockPage from "./pages/LockPage";
import TokenCreator from "./pages/TokenCreator";
import TokenDetails from "./pages/TokenDetails";
import TokenDetails2 from "./pages/TokenDetails2";
import TokenDetails3 from "./pages/TokenDetails3";


// Import the wallet styles
import '@solana/wallet-adapter-react-ui/styles.css';

function App() {
  // Setup for Solana network and wallet adapters
  const network = WalletAdapterNetwork.Mainnet; // or 'Devnet', 'Testnet'
  const endpoint = clusterApiUrl(network);
  const wallets = [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
    // Add other wallet adapters here
  ];

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/launchpad-list" element={<LaunchpadList />} />
              <Route path="/token-creator" element={<TokenCreator />} />
              <Route path="/lock-page" element={<LockPage />} />
              <Route path="/solchat-presale" element={<TokenDetails />} />
              <Route path="/sample-presale" element={<TokenDetails2 />} />
              <Route path="/octonetai-presale" element={<TokenDetails3 />} />


              {/* Add more routes as needed */}
            </Routes>
          </BrowserRouter>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default App;
